import { getRequest } from './methods/getRequest';

export const requestBlob = (requestUrl: string) =>
  getRequest(requestUrl).then((response) => response.blob());
